module.exports = __webpack_public_path__ + "img/SPFCU_Logo.7c24a67d.png";